// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NgXGG","footer":"styles_footer__3ttcI"};